import { Popover } from "antd";
import dayjs from "dayjs";
import React from "react";
import { Seed, SeedItem, SeedTeam } from "react-brackets";

function CustomSeed({ seed, breakpoint, chooseMatchWinner, roundIndex }) {
  return (
    <>
      <Seed mobileBre akpoint={breakpoint} style={{ fontSize: 12 }}>
        <Popover
          trigger={["hover"]}
          title="Match Time"
          content={
            <p className="start-end-time">
              From: {seed?.startTime ? dayjs(seed?.startTime).format("MM:DD:YYYY hh:mm A") : ""}{" "}
              <br />
              To: {seed?.startTime ? dayjs(seed?.endTime).format("MM:DD:YYYY hh:mm A") : ""}
            </p>
          }>
          <SeedItem>
            <div>
              <SeedTeam
                className={seed?.win?._id === seed?.team1?._id ? "winning-team" : ""}
                onClick={
                  seed?.win?._id === seed?.team1?._id
                    ? () => {}
                    : () =>
                        chooseMatchWinner({
                          winner: seed?.team1,
                          opponent: seed?.team2,
                          data: { ...seed, roundIndex }
                        })
                }>
                {seed?.team1?.name || "TBD "}
              </SeedTeam>
              <SeedTeam
                className={seed?.win?._id === seed?.team2?._id ? "winning-team" : ""}
                onClick={
                  seed?.win?._id === seed?.team2?._id
                    ? () => {}
                    : () =>
                        chooseMatchWinner({
                          winner: seed?.team2,
                          opponent: seed?.team1,
                          data: { ...seed, roundIndex }
                        })
                }>
                {seed?.team2?.name || "TBD "}
              </SeedTeam>
            </div>
          </SeedItem>
        </Popover>
      </Seed>
    </>
  );
}

export default CustomSeed;
